export default __webpack_public_path__ + "static/media/eng.a73a3f28.png";